import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import { graphql } from "gatsby"
import { connect } from "react-redux"
import { fetchJobs } from "store/actions/job"
import { getSearchParams } from "gatsby-query-params";

import GlobalStateProvider from "context/provider"
import Layout from "components/layout"
import SEO from "components/seo"
import Hero from "components/sections/category/hero"
import Clients from "components/sections/clients"
import Demos from "components/sections/category/demos"
import Grid from "components/sections/grid"
import Breadcumbs from "components/common/breadcumbs"
import Searching from "components/job/searching"
import peopleImg from "content/images/people.svg"
import PrimaryCard from "components/common/primaryCard"
import docImg from "content/images/search.svg"
import fileImg from "content/images/file.svg"
import jobAskingImg from "components/assets/job-asking.png"

const jobScoring = "https://hrflow-ai.imgix.net/labs/talent-copilot.jpg?w=350&h=350&fit=clip"

const StyledGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: 2rem;
  margin-bottom: 2rem;
  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    grid-template-columns: 1fr 1fr;
  }
`
const JobSearchingPage = (
  {
    data,
    fetchJobs,
    jobs,
  }) => {
  const { frontmatter } = data.index.edges[0].node
  const { seoTitle, useSeoTitleSuffix, useSplashScreen } = frontmatter
  const queryParams = getSearchParams()

  const globalState = {
    // if useSplashScreen=false, we skip the intro by setting isIntroDone=true
    isIntroDone: useSplashScreen ? false : true,
    // darkMode is initially disabled, a hook inside the Layout component
    // will check the user's preferences and switch to dark mode if needed
    darkMode: false,
  }


  return (
    <GlobalStateProvider initialState={globalState}>
      <Layout>
        <SEO
          frontmatter={frontmatter}
        />
        <Breadcumbs
          color="#2A7CF8"
          text="Job analysis"
          link="/job-analysis/"
          logo={fileImg}
        />
        <Hero
          content={data.hero.edges}
          color="#2A7CF8"
          resultPage={queryParams?.key}
          docs="https://developers.hrflow.ai/reference/search-jobs"
        />
        <Grid form>
          <Searching
            fetchJobs={fetchJobs}
            jobs={jobs}
          />
        </Grid>
        <Clients content={data.clients.edges} category />
        <Demos content={data.demos.edges}>
          <StyledGrid className="mt-2">
            <PrimaryCard
              image={jobScoring}
              color="#2A7CF8"
              title="Talent Copilot"
              link="/job-analysis/talent-copilot/"
              subtitle="Our AI-powered Talent Copilot is designed to help your candidates, employees, or job seekers identify the most qualified job opening for them."
            />
            <PrimaryCard
              image={jobAskingImg}
              color="#2A7CF8"
              title="Job asking"
              link="/job-analysis/asking/"
              subtitle="Ask a question based on a Job object with HrFlow.ai Job Asking API."
            />
          </StyledGrid>
        </Demos>
      </Layout>
    </GlobalStateProvider>
  )
}

JobSearchingPage.propTypes = {
  data: PropTypes.object.isRequired,
}

const mapStateToProps = state => ({
	jobs: state.job.jobSearching,
})

export default connect(mapStateToProps, { fetchJobs })(JobSearchingPage)

export const pageQuery = graphql`
  {
    index: allMdx(filter: { fileAbsolutePath: { regex: "/job/searching/index/" } }) {
      edges {
        node {
          frontmatter {
            seoTitle
            seoImage
            url
            description
            keywords
            useSeoTitleSuffix
            useSplashScreen
          }
        }
      }
    }
    hero: allMdx(filter: { fileAbsolutePath: { regex: "/job/searching/hero/" } }) {
      edges {
        node {
          frontmatter {
            title
            description
          }
        }
      }
    }
    clients: allMdx(filter: { fileAbsolutePath: { regex: "/home/clients/" } }) {
      edges {
        node {
          exports {
            shownItems
            clients {
              alt
              logo {
                childImageSharp {
                  gatsbyImageData(layout: CONSTRAINED, width: 300, quality: 90, placeholder: NONE)
                }
              }
            }
          }
          frontmatter {
            title
          }
        }
      }
    }
    demos: allMdx(filter: { fileAbsolutePath: { regex: "/text/linking/demos/" } }) {
      edges {
        node {
          frontmatter {
            label
            title
            titlePrefix
            description
          }
        }
      }
    }
  }
`